import {
  academicZoneACodes,
  academicZoneBCodes,
  academicZoneCCodes,
  frenchAcademicZoneCountries
} from '../../../../lib/constants/academic-zone-codes'
import { AcademicZoneEnum } from '../../../../lib/types/enums/staff/academic-zone.enum'

// Department of a french postal code: "75014" -> "75", overseas "97110" -> "971", Corsica "20000" -> "20"
export const getStaffAcademicZone = (
  postalCode?: string | null,
  country?: string | null
): AcademicZoneEnum => {
  const normalizedCountry = country
    ?.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
  if (!normalizedCountry || !frenchAcademicZoneCountries.includes(normalizedCountry))
    return AcademicZoneEnum.NONE

  const normalizedPostalCode = postalCode?.replace(/\s/g, '')
  if (!normalizedPostalCode || !/^\d{5}$/.test(normalizedPostalCode)) return AcademicZoneEnum.NONE

  const code = normalizedPostalCode.startsWith('97')
    ? normalizedPostalCode.substring(0, 3)
    : normalizedPostalCode.substring(0, 2)
  if (academicZoneACodes.includes(code)) return AcademicZoneEnum.A
  if (academicZoneBCodes.includes(code)) return AcademicZoneEnum.B
  if (academicZoneCCodes.includes(code)) return AcademicZoneEnum.C
  return AcademicZoneEnum.NONE
}
